import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntegrationsPreview() {
  const integrations = ['Slack', 'Gmail', 'Google Ads', 'Meta', 'Salesforce', 'HubSpot', 'Stripe', 'QuickBooks', 'Twilio', 'Zapier', 'Calendly', 'Shopify', 'ClickUp', 'Asana', 'Monday', 'Linear', 'Notion', 'Airtable', 'Mailchimp', 'ActiveCampaign', 'Intercom', 'Zendesk', 'Discord', 'Teams'];
  return <>
      {/* Gradient Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-purple/20 to-transparent" data-id="element-348" data-mp="3ef8e3mw1ynm6" />

      <section className="section-padding bg-white relative overflow-hidden" data-id="element-349" data-mp="3ihbtgmlueccq">
        {/* Subtle Ambient Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal/5 rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-350" data-mp="to7our7eevte" />

        <div className="inner-container text-center relative z-10" data-id="element-351" data-mp="1u5ruq0zrik4d">
          <div className="max-w-3xl mx-auto mb-16" data-id="element-352" data-mp="1u2vwebk05tfe">
            <span className="text-teal text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-353" data-mp="1p76tby8rxuec">
              Integrations
            </span>
            <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-gray-900" data-id="element-354" data-mp="1k8wwzkbbcnr5">
              MISTR Connects to Your Entire World.
            </h2>
          </div>

          <div className="flex flex-wrap justify-center gap-4 max-w-5xl mx-auto mb-12" data-id="element-355" data-mp="1b8gvuhi1lspg">
            {integrations.map((brand, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i % 8 * 0.05
          }} className="bg-white border border-gray-200 rounded-full px-6 py-3 font-poppins font-medium text-sm text-gray-600 hover:text-teal hover:border-teal/40 hover:shadow-md hover:shadow-teal/5 transition-all cursor-default" data-id="element-356" data-mp="11g1enmekl85m" data-mpi={i}>
                {brand}
              </motion.div>)}
          </div>

          <Link to="/integrations" className="inline-flex items-center gap-2 font-poppins font-semibold text-teal hover:text-purple transition-colors group" data-id="element-357" data-mp="8w7393xxb1w2">
            See All Integrations{' '}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-358" data-mp="mudrrtgzfpj2" />
          </Link>
        </div>
      </section>
    </>;
}